import { LOCALE } from 'helpers/i18n';
import { DOMAIN_PREFIX_BY_LOCALES } from 'config';

const getDomainPrefix = (locale) => DOMAIN_PREFIX_BY_LOCALES[locale];

export const DOMAIN_PREFIX = getDomainPrefix(LOCALE);
